import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('onboardingStepCount');

    return {
        STEP_COUNT: (stepCount: string) => t('stepCount', { stepCount })
    };
};

export default useTranslation;
